/// <reference path="./MultiText.ts" />
namespace HA.Core.HTML.Editor {
    export class File extends MultiText {
        /**
         * @returns {Array}
         */
        public getSelections() {
            const data = [];
            this.getItems().forEach((s: SelectorItem) => {
                if (s.isChecked()) {
                    data.push(s.getValue());
                }
            });

            return data;
        }

        /**
         * @returns {Map}
         */
        protected getItems() {
            return this.getList().getItems();
        }

        /**
         *
         * @returns {List}
         */
        protected getList() {
            return this.get("list");
        }

        protected addFiles(files: File[]) {
            for (let i = 0; i < files.length; i++) {
                this.addFile(files[i]);
            }
        }

        protected addFile(file: any) {
            if (file && !this.getList().hasValue(file.name)) {
                const imgContainer = new FileContainer(toMap({f: file}));
                const div = new Div({className: "thumb"});
                div.appendChild(new Img(toMap({src: this.getFileIcon(file)})));
                imgContainer.appendChild(div);
                this.getList().addItem(new ImageItem(toMap({item: imgContainer, s: true})));
            }
        }

        protected getFileIcon(file: any): string {
            switch (file.type) {
                case "application/pdf":
                    return "/file/ha/svg/file_pdf";
                case "application/json":
                    return "/file/ha/svg/file_json";
                default:
                    return "/file/ha/svg/file_pdf";
            }
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.SelectorItem}
         */
        protected createItem(data: any) {
            return new TextItem(data);
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.MultiTextHead}
         */
        protected createHead(data?: any) {
            const me = this;
            return new MultiTextHead(toMap({
                accept: ".json,application/json,.pdf,application/pdf",
                ed: {
                    addFiles: (files?: File[]) => {
                        if (files) {
                            me.addFiles(files);
                        }
                    },
                },
                t: "json",
            }));
        }
    }
}
